import React from 'react'

import { Box, Grid } from '@mui/material'
import { type EditAssetHolderProps } from './EditAssetHolderForm'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import { ProjectStatusChip } from '../../components/chips/ProjectStatusChip'
import CurrencyCodeChip from '../../components/chips/CurrencyCodeChip'

const EditAssetHolderInstructionsView: React.FC<EditAssetHolderProps> = ({
  assetHolder
}: EditAssetHolderProps) => {
  const accumulationColumns: GridColDef[] = [
    { field: 'id', headerName: 'Id', flex: 12, editable: false },
    { field: 'projectId', headerName: 'Project #', flex: 12, editable: false },
    { field: 'projectName', headerName: 'Project Name', flex: 50, editable: false },
    {
      field: 'projectStatus',
      headerName: 'Project Status',
      flex: 20,
      editable: false,
      renderCell: params => (
        <ProjectStatusChip projectStatus={params.row.projectStatus}/>
      )
    },
    {
      field: 'currencyUnit',
      headerName: 'Currency Unit',
      flex: 15,
      align: 'center',
      renderCell: params => (
        <CurrencyCodeChip name={''} code={params.row.currencyUnit}/>
      )
    },
    { field: 'expiredAt', headerName: 'Expired At', flex: 20, editable: false },
    { field: 'supersededBy', headerName: 'Superseded By', flex: 20, editable: false }
  ]

  const charityColumns: GridColDef[] = [
    { field: 'id', headerName: 'Id', flex: 12, editable: false },
    { field: 'projectId', headerName: 'Project #', flex: 12, editable: false },
    { field: 'projectName', headerName: 'Project Name', flex: 50, editable: false },
    {
      field: 'projectStatus',
      headerName: 'Project Status',
      flex: 20,
      editable: false,
      renderCell: params => (
        <ProjectStatusChip projectStatus={params.row.projectStatus}/>
      )
    },
    { field: 'organisationId', headerName: 'Org. #', flex: 12, editable: false },
    { field: 'organisationName', headerName: 'Organisation Name', flex: 50, editable: false },
    { field: 'percentageDistribution', headerName: 'Percentage', flex: 20, editable: false },
    { field: 'expiredAt', headerName: 'Expired At', flex: 20, editable: false },
    { field: 'supersededBy', headerName: 'Superseded By', flex: 20, editable: false }
  ]

  return (
    <>
        <Box sx={{ pb: 4 }}>
          <h3>Accumulation Currency Instructions</h3>
          <Grid container spacing={4} >
            <Grid item md={12}>
              <DataGrid rows={assetHolder.accumulationInstructions} columns={accumulationColumns} autoHeight={true} pageSize={10} rowsPerPageOptions={[10]} />
            </Grid>
          </Grid>
        </Box>

        {/* ==================================================================================================== */}

      <br/>
      <br/>
      <Box sx={{ pb: 4 }}>
        <h3>Charity Contribution Instructions</h3>
        <Grid container spacing={4} >
          <Grid item md={12}>
            <DataGrid rows={assetHolder.charityInstructions} columns={charityColumns} autoHeight={true} pageSize={10} rowsPerPageOptions={[10]} />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default EditAssetHolderInstructionsView
